module.exports = __webpack_public_path__ + "2e1a44dfe8271dc0e9908cbee372dd17.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/sofas/sofa-chef.png
// module id = 3424
// module chunks = 0